module.exports = __webpack_public_path__ + "img/duels.15c37cb4.png";